import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { pontuaCpfCnpj } from '~/utils/functions';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class PDFGenerator {
  private docDefinition: any;

  constructor(private rows: any[], private infoLoja: any) {
    this.docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [30, 85, 30, 40],
      defaultStyle: {
        fontSize: 9.5,
      },
      header: this.createHeader(),
      content: this.createContent(),
    };
    console.log(infoLoja);
  }
  private createHeader() {
    return () => {
      const { infoLoja } = this;
      return [
        {
          layout: 'noBorders',
          table: {
            widths: ['100%'],
            headerRows: 3,
            body: [
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['50%', '50%'],
                    body: [
                      [
                        {
                          text: `${infoLoja.des_loja}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, 0, 0, 0],
                        },
                        {
                          text: `Relatório Análise de Hábito de Consumo`,
                          alignment: 'right',
                          fontSize: 9,
                          margin: [0, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['85%', '15%'],
                    body: [
                      [
                        {
                          text: `${infoLoja.des_logradouro} - Nº: ${infoLoja.num_endereco} - ${infoLoja.des_bairro} CEP ${infoLoja.num_cep} ${infoLoja.des_cidade} - ${infoLoja.des_uf}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, -7.5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
              [
                {
                  layout: 'noBorders',
                  table: {
                    widths: ['100%'],
                    body: [
                      [
                        {
                          text: `CNPJ: ${pontuaCpfCnpj(infoLoja.num_cnpj)}`,
                          alignment: 'left',
                          bold: true,
                          margin: [0, -7.5, 0, 0],
                        },
                      ],
                    ],
                  },
                },
              ],
            ],
          },
          margin: [30, 30, 30, 15],
        },
      ];
    };
  }

  private createContent() {
    const { rows } = this;

    const tableBody = [
      [
        { text: 'PLU', style: 'tableHeader', bold: true, alignment: 'center' },
        {
          text: 'Produto',
          style: 'tableHeader',
          bold: true,
          alignment: 'center',
        },
        {
          text: 'Cliente',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Qtd',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Dta Últ. Vda',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Qtd Dias Média',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
        {
          text: 'Dta Próx. Vda',
          style: 'tableHeader',
          alignment: 'center',
          bold: true,
        },
      ],
      ...rows.map((item: any) => [
        {
          text: item.cod_produto,
          alignment: 'left',
        },
        { text: item.des_produto, alignment: 'right' },
        { text: item.des_cliente, alignment: 'right' },
        { text: item.qtd_vendida, alignment: 'right' },
        { text: item.dataUltimaVenda, alignment: 'right' },
        { text: item.qtd_dias_media, alignment: 'right' },
        { text: item.dataProxVenda, alignment: 'right' },
      ]),
    ];
    return {
      table: {
        widths: ['10%', '20%', '20%', '10%', '15%', '12%', '13%'],
        body: tableBody,
      },
    };
  }

  public generatePDF(): void {
    try {
      const pdfDocGenerator = pdfMake.createPdf(this.docDefinition);
      pdfDocGenerator.open();
    } catch (error) {
      console.log('Erro ao gerar o PDF:', error);
    }
  }
}
